import type { Editor, VecLike } from "./canvas";

// The canvas menu's Paste: shapes, text, images and files from the system
// clipboard. The menu lives outside the canvas, so the board registers this
// action once the canvas is mounted.
export const pasteAtCanvasPoint = new WeakMap<
  Editor,
  (point: VecLike) => Promise<void>
>();
